import { KeyCode } from '../util/keycode';
import { Util } from './util';

// TODO: Refactor this so that addEventListener is only called once

export interface IKBEvent {
    code: KeyCode,
    ctrl?: boolean,
    shift?: boolean,
    preventDefault?: boolean,
}

/* Keypress is deprecated, so we use keydown and keyup */
export class Kb {
    public static on(
        event: IKBEvent,
        keydown: (e: KeyboardEvent) => void,
        keyup?: (e: KeyboardEvent) => void
    ) {
        const keydownAction = (keydownEvent: KeyboardEvent) => {
            const target = (keydownEvent.target as HTMLElement);
            if ((target.nodeName == 'INPUT') && ((target.id === 'command') && (!event.ctrl) && (!event.shift))) return;
            if (event.ctrl == true && keydownEvent.ctrlKey === false) return;
            if (event.ctrl == false && keydownEvent.ctrlKey === true) return;
            if (event.shift == true && keydownEvent.shiftKey === false) return;
            if (event.shift == false && keydownEvent.shiftKey === true) return;

            if (keydownEvent.code == event.code ||
                (event.code == 'Affirmative' && Util.isAffirmativeKey(keydownEvent))
            ) {
                keydown(keydownEvent);

                if (event.preventDefault == true) {
                    keydownEvent.preventDefault();
                }
            }
        }

        document.addEventListener('keydown', keydownAction);

        /* EARLY RETURN IF THERE IS NO KEYUP DEFINED */
        if (keyup == undefined) {
            return {
                unsubscribe: () => document.removeEventListener('keydown', keydownAction)
            }
        };

        const keyupAction = (keyupEvent: KeyboardEvent) => {
            const target = (keyupEvent.target as Node).nodeName;
            if (target == 'INPUT') return;
            if (event.ctrl == true && keyupEvent.ctrlKey === false) return;
            if (event.ctrl == false && keyupEvent.ctrlKey === true) return;
            if (event.shift == true && keyupEvent.shiftKey === false) return;
            if (event.shift == false && keyupEvent.shiftKey === true) return;

            if (keyupEvent.code == event.code ||
                (keyupEvent.code == 'Affirmative' && Util.isAffirmativeKey(keyupEvent))
            ) {
                keyup(keyupEvent);

                if (event.preventDefault == true) {
                    keyupEvent.preventDefault();
                }
            }
        }

        document.addEventListener('keyup', keyupAction);

        return {
            unsubscribe: () => {
                document.removeEventListener('keydown', keydownAction);
                document.removeEventListener('keyup', keydownAction);
            }
        }
    }
}
